<template>
  <a class="c-header-link-card" :href="linkItem.url">
    <div
      class="c-header-link-card__image"
      :style="{ backgroundImage: `url(${linkItem.image})` }"
    ></div>
    <h3
      class="c-header-link-card__title"
      v-html="linkItem.getMarkedTitle(markWord)"
    ></h3>
  </a>
</template>

<script>
import { LinkItem } from '~/js/models/linkItem'

export default {
  name: 'ComponentHeaderLinkCard',
  props: {
    markWord: { type: String, default: '' },
    linkItem: { type: LinkItem, default: null },
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/reset-new';
@use '~/scss/generic/variables';

.c-header-link-card {
  display: flex;
  transition: 0.3s;

  &:hover {
    opacity: 0.6;
  }

  &__image {
    background-position: center center;
    background-size: cover;
    border-radius: 8px;
    flex-shrink: 0;
    height: 60px;
    width: 60px;
  }

  &__title {
    display: -webkit-box;
    font-weight: 600;
    font-size: 14px;
    flex-grow: 1;
    margin-left: 16px;
    height: 3em * 1.5;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;

    :deep(mark) {
      background-color: variables.$color-pink;
      padding: 2px;
    }
  }
}
</style>
